import React from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Tooltip,
} from "@mui/material";
import dayjs from "dayjs";
import DatePickerComponent from "../../../../../common/components/date-picker/date-picker-compoenent";
import CloseIcon from "../../../../../assets/icons/closeIcon.svg";
import "./company-dashboard-initiative-drawer-side-bar.scss";

const CompanyDashboardInitiativeDrawerSideBarTimelinePopup: any = (
  props: any,
) => {
  const {
    isShowEditTimeline,
    setIsShowEditTimeline,
    timelineData,
    handleCreateInitiative,
    payloadData,
  } = props;

  const validationSchema = () =>
    Yup.object().shape({
      startDate: Yup.date()
        .nullable()
        .transform((value, originalValue) => {
          // Ensure empty string => null
          return originalValue === "" ? null : value;
        })
        .typeError("Please select a valid Start Date")
        .min(new Date(1900, 0, 1), "Start Date must be after 1900")
        .required("Start Date is required")
        .test(
          "start-before-end",
          "Start Date cannot be after End Date",
          function (value, context) {
            const { endDate } = context.parent;
            if (value && endDate) {
              return value <= endDate;
            }
            return true;
          },
        ),
      endDate: Yup.date()
        .nullable()
        .transform((value, originalValue) => {
          return originalValue === "" ? null : value;
        })
        .typeError("Please select a valid End Date")
        .min(new Date(1900, 0, 1), "End Date must be after 1900")
        .required("End Date is required")
        .test(
          "end-after-start",
          "End Date cannot be earlier than Start Date",
          function (value, context) {
            const { startDate } = context.parent;
            if (value && startDate) {
              return value >= startDate;
            }
            return true;
          },
        ),
    });
  return (
    <Dialog
      open={isShowEditTimeline}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className={`company-dashboard-initiative-drawer-side-bar-details-popup `}
      onClose={(event, reason) => {
        if (reason === "backdropClick") {
          return;
        }
        setIsShowEditTimeline();
      }}
    >
      <DialogTitle id="alert-dialog-title">
        <div className="header-wrapper">
          <div className="header-wrapper-text">Timeline</div>
          <div className="image-wrapper">
            <button
              style={{
                border: "none",
                background: "none",
                padding: 0,
              }}
              onClick={() => setIsShowEditTimeline(false)}
            >
              <img
                alt="Close"
                src={CloseIcon}
                className="close-icon"
                style={{ cursor: "pointer" }}
              />
            </button>
          </div>
        </div>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <Formik
            initialValues={{
              startDate: dayjs(timelineData?.startDate) || null,
              endDate: dayjs(timelineData?.endDate) || null,
            }}
            validationSchema={validationSchema}
            validateOnChange={true}
            enableReinitialize={true}
            onSubmit={(values: any) => {
              handleCreateInitiative(setIsShowEditTimeline, {
                ...payloadData,
                startDate: values?.startDate || new Date(),
                endDate: values?.endDate || new Date(),
              });
            }}
          >
            {({ values, setFieldValue, isValid, submitCount }) => (
              <Form>
                <div className="company-dashboard-initiative-drawer-side-bar-details-popup-edit">
                  <div className="company-dashboard-initiative-drawer-side-bar-details-popup-edit-content">
                    <div className="form-group">
                      <DatePickerComponent
                        fieldName={"startDate"}
                        label="Start Date"
                        value={values?.startDate}
                        minDate={dayjs("1900-01-01")}
                        maxDate={
                          values.endDate ? dayjs(values.endDate) : undefined
                        } // 👈 disables after endDate
                        onChange={(e: any) => {
                          setFieldValue("startDate", e);
                        }}
                      />
                    </div>
                    <div className="form-group">
                      <DatePickerComponent
                        fieldName={"endDate"}
                        label="End Date"
                        minDate={
                          values.startDate
                            ? dayjs(values.startDate)
                            : dayjs("1900-01-01")
                        }
                        value={values?.endDate}
                        onChange={(e: any) => {
                          setFieldValue("endDate", e);
                        }}
                      />
                    </div>
                  </div>
                  <div className="company-dashboard-initiative-drawer-side-bar-details-popup-edit-action">
                    <button
                      className="company-dashboard-initiative-drawer-side-bar-details-popup-edit-action-cancel"
                      onClick={() => setIsShowEditTimeline(false)}
                      type="button"
                    >
                      Cancel
                    </button>
                    {submitCount > 0 && !isValid ? (
                      <Tooltip
                        title="Please resolve all errors before submitting."
                        placement="top"
                      >
                        <span>
                          <button
                            className="company-dashboard-initiative-drawer-side-bar-details-popup-edit-action-save"
                            type="submit"
                            disabled
                            style={{
                              opacity: 0.5,
                              cursor: "not-allowed",
                            }}
                          >
                            Save
                          </button>
                        </span>
                      </Tooltip>
                    ) : (
                      <button
                        className="company-dashboard-initiative-drawer-side-bar-details-popup-edit-action-save"
                        type="submit"
                        style={{
                          opacity: 1,
                          cursor: "pointer",
                        }}
                      >
                        Save
                      </button>
                    )}
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
};

export default CompanyDashboardInitiativeDrawerSideBarTimelinePopup;
